import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { useCancelAnonymousSubscription } from '../../../hooks/api/cancelAnonymousSubscription/use-cancel-anonymous-subscription.js';
import '@swc/helpers';
import '@grandvisionhq/common';
import '@grandvisionhq/graphql';
import '@grandvisionhq/utils';
import '../../../operations/mutations/cancel-anonymous-subscription.js';
import '../../../operations/mutations/cancel-subscription.js';
import { useCancellationReason } from '../hooks/use-cancellation-reason.js';
import { AnonymousCancelSubscriptionForm } from './AnonymousCancelSubscriptionForm.js';

const AnonymousCancelSubscriptionContainer = ()=>{
    const [subscriptionNumber1, setSubscriptionNumber] = React.useState('');
    const [email1, setEmail] = React.useState('');
    const [isSuccess, setIsSuccess] = React.useState(false);
    const { getLabel , getFormattedLabel , dateTime  } = useIntl();
    const formRef = React.useRef(null);
    const { selectedCancellationType , handleFormChange: handleReasonChange , getReasonFromForm ,  } = useCancellationReason();
    const labels = React.useMemo(()=>({
            subscriptionNumber: {
                label: getLabel('cancelSubscription.field.subscriptionNumber'),
                placeholder: getLabel('cancelSubscription.field.subscriptionNumber.placeholder'),
                errorMessage: getLabel('cancelSubscription.field.subscriptionNumber.errorMessage')
            },
            email: {
                label: getLabel('cancelSubscription.field.email'),
                placeholder: getLabel('cancelSubscription.field.email.placeholder'),
                errorMessage: getLabel('cancelSubscription.field.email.errorMessage')
            },
            postalCode: {
                label: getLabel('cancelSubscription.field.postalCode'),
                placeholder: getLabel('cancelSubscription.field.postalCode.placeholder'),
                errorMessage: getLabel('cancelSubscription.field.postalCode.errorMessage')
            },
            cancellationDate: {
                label: getLabel('cancelSubscription.field.cancellationDate'),
                placeholder: dateTime.formatMidsizeDate(new Date()),
                errorMessage: getLabel('cancelSubscription.field.cancellationDate.errorMessage')
            },
            submit: getLabel('cancelSubscription.action.submit'),
            success: {
                title: getFormattedLabel('cancelSubscription.success.title', {
                    labelData: {
                        subscriptionNumber: subscriptionNumber1
                    }
                }),
                description: getFormattedLabel('cancelSubscription.success.description', {
                    labelData: {
                        email: email1
                    }
                })
            },
            formAriaLabel: getLabel('cancelSubscription.title')
        })
    , [
        getLabel,
        getFormattedLabel,
        dateTime,
        subscriptionNumber1,
        email1
    ]);
    const handleOnCompleted = React.useCallback(()=>{
        var ref;
        setIsSuccess(true);
        (ref = formRef.current) === null || ref === void 0 ? void 0 : ref.resetForm();
        globalThis.window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, []);
    const { cancelAnonymousSubscription , isUpdating  } = useCancelAnonymousSubscription({
        onCompleted: handleOnCompleted
    });
    const handleSubmit = React.useCallback(({ formState  })=>{
        var ref, ref1, ref2, ref3, ref4;
        if (((ref = formState.subscriptionNumber) === null || ref === void 0 ? void 0 : ref.value) && ((ref1 = formState.email) === null || ref1 === void 0 ? void 0 : ref1.value) && ((ref2 = formState.postalCode) === null || ref2 === void 0 ? void 0 : ref2.value) && ((ref3 = formState.cancellationDate) === null || ref3 === void 0 ? void 0 : ref3.value) && ((ref4 = formState.cancellationType) === null || ref4 === void 0 ? void 0 : ref4.value)) {
            const reason = getReasonFromForm(formState);
            if (!reason) return;
            const email = formState.email.value.toLowerCase();
            const subscriptionNumber = formState.subscriptionNumber.value;
            const postalCode = formState.postalCode.value;
            const cancellationDate = formState.cancellationDate.value;
            const cancellationType = formState.cancellationType.value;
            setIsSuccess(false);
            setSubscriptionNumber(subscriptionNumber);
            setEmail(email);
            cancelAnonymousSubscription(subscriptionNumber, {
                email,
                postalCode,
                cancelDate: cancellationDate,
                cancelType: cancellationType,
                cancelReason: reason
            });
        }
    }, [
        cancelAnonymousSubscription,
        getReasonFromForm
    ]);
    const resetFormFields = React.useCallback(()=>{
        setSubscriptionNumber('');
        setEmail('');
        setIsSuccess(false);
    }, []);
    const handleBlur = React.useCallback(()=>{
        if (isSuccess) {
            resetFormFields();
        }
    }, [
        isSuccess,
        resetFormFields
    ]);
    const handleFormChange = React.useCallback((formState)=>{
        handleReasonChange(formState);
        if (isSuccess) {
            resetFormFields();
        }
    }, [
        handleReasonChange,
        isSuccess,
        resetFormFields
    ]);
    return /*#__PURE__*/ React.createElement(AnonymousCancelSubscriptionForm, {
        formRef: formRef,
        isSuccess: isSuccess,
        isUpdating: isUpdating,
        labels: labels,
        onBlur: handleBlur,
        onChange: handleFormChange,
        onSubmit: handleSubmit,
        selectedCancellationType: selectedCancellationType
    });
};

export { AnonymousCancelSubscriptionContainer };
//# sourceMappingURL=AnonymousCancelSubscriptionContainer.js.map
